"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WindowStrategy = void 0;
var WindowStrategy = /*#__PURE__*/function () {
  function WindowStrategy() {
    var _this = this;
    var mainnet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "https://h4n.app";
    var testnet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "https://my.herewallet.app";
    _classCallCheck(this, WindowStrategy);
    this.mainnet = mainnet;
    this.testnet = testnet;
    this.signWindow = null;
    this.onFailed = function () {
      return _this.close();
    };
    this.onSuccess = function () {
      return _this.close();
    };
  }
  _createClass(WindowStrategy, [{
    key: "onInitialized",
    value: function onInitialized() {
      if (this.signWindow) return;
      var left = window.innerWidth / 2 - 420 / 2;
      var top = window.innerHeight / 2 - 700 / 2;
      this.signWindow = window.open("https://my.herewallet.app/loading", "_blank", "popup=1,width=420,height=700,top=".concat(top, ",left=").concat(left));
    }
  }, {
    key: "onRequested",
    value: function onRequested(id, request, reject) {
      var _this2 = this;
      var _a;
      if (this.signWindow == null) return;
      this.unloadHandler = function () {
        var _a;
        return (_a = _this2.signWindow) === null || _a === void 0 ? void 0 : _a.close();
      };
      window.addEventListener("beforeunload", this.unloadHandler);
      var network = (_a = request.network) !== null && _a !== void 0 ? _a : "mainnet";
      this.signWindow.location = "".concat(network ? this.testnet : this.mainnet, "/").concat(id);
      this.timerHandler = setInterval(function () {
        var _a;
        if ((_a = _this2.signWindow) === null || _a === void 0 ? void 0 : _a.closed) reject("CLOSED");
      }, 1000);
    }
  }, {
    key: "close",
    value: function close() {
      var _a;
      clearInterval(this.timerHandler);
      (_a = this.signWindow) === null || _a === void 0 ? void 0 : _a.close();
      this.signWindow = null;
      if (this.unloadHandler) {
        window.removeEventListener("beforeunload", this.unloadHandler);
      }
    }
  }]);
  return WindowStrategy;
}();
exports.WindowStrategy = WindowStrategy;